export const CLOCK_IN_OUT = "Employee Check-in"

export const CLOCK_IN_OUT_PAGES = {
    TABLE: "table",
}
// tooltip names
export const BACK = "Back to Menu"
